import React from "react"
import { Link } from "react-router-dom";
import CrossIcon from '../../assets/images/lystfacelogos/CrossIcon.svg'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

//ui-cmd-4
const CustomPopup = ({ popupDetails }) => {
    const { open, type, title, titleText, bodyText, toggle = false, primaryButtonText, secondaryButtonText, primaryButtonPath, secondaryButtonPath, handleClickPrimaryButton, handleClickSecondaryButton, handleClose, subText, inputRef, primaryLoading, className, primaryButtonType, secondaryButtonType } = popupDetails

    return (
        <div className="modal-right">
            <Modal isOpen={open} className={`popup-container ${title === "setup" ? "setup" : ""} ${className ? className : ""}`}
                toggle={toggle ? handleClose : null}
            >
                {titleText &&
                    <div className="modal-header">
                        <div className="title">{titleText}</div>
                        {handleClose && <div className="close-icon" onClick={handleClose}><img src={CrossIcon} /></div>}
                    </div>
                }

                <ModalBody className="modal-body">
                    <p className="body-text">{bodyText}</p>
                    {subText &&
                        <div className="sub-text" ref={inputRef}>
                            <div>
                                {subText.split(',')[0]}
                            </div>
                            <div>
                                {subText.split(',')[1]}
                            </div>
                        </div>}

                </ModalBody>
                <ModalFooter className="modal-footer">
                    {secondaryButtonText &&
                        <Button className={`popup-button-secondary ${secondaryButtonType === "black" ? "black" : ""} ${type === "danger" ? "danger" : ""}`} onClick={handleClickSecondaryButton} >
                            {secondaryButtonText}
                        </Button>}
                    {primaryButtonText && <Button className={`popup-button-primary ${primaryButtonType === "danger" ? "danger" : ""} ${primaryLoading ? "disabled" : ""}`} onClick={() => handleClickPrimaryButton(title)}>
                        {primaryButtonText}
                        {(primaryLoading) &&
                            <div className="spinner-container spinner-border">
                            </div>}
                    </Button>}
                </ModalFooter>
            </Modal>
        </div>
    )
}

export default CustomPopup
